import { createContext, ReactNode, useContext, useMemo } from 'react'
import { NextpeakPublicClient } from './nextpeakPublic.client.ts'
import { NEXTPEAK_API_URL } from '../../config.ts'
import { HttpClientFactory } from '../httpClient'

const NextPeakPublicClientContext = createContext<NextpeakPublicClient | null>(null)

export interface NextPeakClientProviderProps {
	children: ReactNode
}

export const NextPeakPublicClientProvider = ({ children }: NextPeakClientProviderProps) => {
	const client = useMemo(() => {
		return new NextpeakPublicClient(
			{
				baseUrl: NEXTPEAK_API_URL,
			},
			new HttpClientFactory()
		)
	}, [])

	return <NextPeakPublicClientContext.Provider value={client}>{children}</NextPeakPublicClientContext.Provider>
}

export const useNextPeakPublicClient = () => {
	const client = useContext(NextPeakPublicClientContext)
	if (!client) throw new Error('nextPeakPublicClient not found in context')
	return client
}
